export default __webpack_public_path__ + "static/media/nuskin-color.dd00912f.svg";